import { DeviceRegistrationRequestType,HeaderRequestFormatType,InstallationRequestType,MothershipRequestType,ConfigListRequestType,ConfigDetailsRequestType} from "./Constants";

class _AppService {


    BLOB_DOWNLOAD_API : string = '/downloadblob/';
    MOTHERSHIP_ID : Number = 4;
    _appInfoApiUrl:string;
    _subscriptionKey: string;
    _cdlsApiUrl : string;
    _deviceRegistrationRequest:DeviceRegistrationRequestType;
    _headerRequestFormat:HeaderRequestFormatType;
    _installationRequest:InstallationRequestType;
    _mothershipRequest:MothershipRequestType;
    _configListRequest:ConfigListRequestType;
    _configDetailsRequest:ConfigDetailsRequestType;

    constructor() {
        this._subscriptionKey = "";
        this._cdlsApiUrl = "";
        this._appInfoApiUrl="";
        this._deviceRegistrationRequest={"RegisterationKey":"","AppType":"Terminal","DeviceCurrentTime":_AppService.getCurrentTimeTicks()};
        this._headerRequestFormat={headers : {Authorization:'',"Ocp-Apim-Subscription-Key":''}};
        this._installationRequest={"AppType":"AppCentral"};
        this._mothershipRequest={"AppType":"AppCentral","DeviceGuid": "00000000000000000000000000000000"};
        this._configListRequest={"AppType": "AppCentral"};
        this._configDetailsRequest={"ConfigurationId":null};
    }

    private static getCurrentTimeTicks(){
        const epochOffset:number = 621355968000000000;
        const ticksPerMillisecond:number = 10000;
        let ticks:number = new Date().getTime() * ticksPerMillisecond + epochOffset;
        return ticks;
     
    }

    get appInfoApiUrl(){
        return this._appInfoApiUrl;
    }

    set appInfoApiUrl(appInfoApiUrl:string){
        this._appInfoApiUrl=appInfoApiUrl;
    }

    get subscriptionKey() {
        return this._subscriptionKey;
    }

    set subscriptionKey(subscriptionKey: string) {
        this._subscriptionKey = subscriptionKey;
    }

    get cdlsApiUrl(){
        return this._cdlsApiUrl;
    }
    
    set cdlsApiUrl(cdlsApiUrl:string){
        this._cdlsApiUrl=cdlsApiUrl;
    }

    get deviceRegistrationUrl(){
        return `${this._cdlsApiUrl}LoginByCode`;
    }

    get deviceRegistrationRequest(){
        return this._deviceRegistrationRequest;
    }

    set deviceRegistrationRequest(deviceRegistrationRequest:DeviceRegistrationRequestType){
        this._deviceRegistrationRequest=deviceRegistrationRequest;
    }

    get headerRequestFormat(){
        return this._headerRequestFormat;
    }

    set headerRequestFormat(headerRequestFormat:HeaderRequestFormatType){
        this._headerRequestFormat=headerRequestFormat;
    }

    get installationUrl(){
        return `${this._cdlsApiUrl}GetAllLicenseProfileByCode`;
    }

    get installationRequest(){
        return this._installationRequest;
    }

    set installationRequest(installationRequest:InstallationRequestType){
        this._installationRequest=installationRequest;
    }

    get mothershipUrl(){
        return `${this._cdlsApiUrl}LicenseProfileGetAllByAuthCode`;
    }


    get mothershipRequest(){
        return this._mothershipRequest;
    }

    set mothershipRequest(mothershipRequest:MothershipRequestType){
        this._mothershipRequest=mothershipRequest;
    }
     

    get configListUrl(){
        return `${this._cdlsApiUrl}LogincodeGetAllConfigByApp`;
    }

    get configListRequest(){
        return this._configListRequest;
    }

    set configListRequest(configListRequest:ConfigListRequestType){
        this._configListRequest=configListRequest;
    }

    get configDetailsUrl(){
        return `${this._cdlsApiUrl}LoginCodeGetConfigById`;
    }

    get configDetailsRequest(){
        return this._configDetailsRequest;
    }

    set configDetailsRequest(configDetailsRequest:ConfigDetailsRequestType){
        this._configDetailsRequest=configDetailsRequest;
    }

     get getAllLicenseByInstanceURL(){
        return `${this._cdlsApiUrl}GetLicensesByInstanceForAppInstaller`;
    }
    
    get getLicenseDecider(){
        return `${this._cdlsApiUrl}licensedecider`;
    }
}

const AppService = new _AppService();
export default AppService;
